import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=98e187c4&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98e187c4')) {
      api.createRecord('98e187c4', component.options)
    } else {
      api.reload('98e187c4', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=98e187c4&", function () {
      api.rerender('98e187c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OI4XHVSXjHV2/JS/comp/costHelpSpa.vue"
export default component.exports